import { render, staticRenderFns } from "./StepperPasoUno.vue?vue&type=template&id=4fb5ca92"
import script from "./StepperPasoUno.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperPasoUno.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports